// 系统字段
import { useDispatch, useSelector } from 'dva';
import styles from './index.less?modules';
import { useEffect, useCallback, createContext } from 'react';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import { isEmptyObject } from '@/utils/comUtil.js';
export const FunctionContext = createContext({
  fetchData: () => {},
});
const Dr = () => {
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['dr/getDiagramApprovalList'];
  const bizData = useSelector((state) => state.dr.diagramApprovalList);
  const searchValue = useSelector((state) => state.dr.searchValue);

  // 条件查询列表
  const fetchData = useCallback(() => {
    dispatch({
      type: 'dr/getDiagramApprovalList',
      payload: {
        values: {
          ...searchValue,
        },
      },
    });
  }, [dispatch, searchValue]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <FunctionContext.Provider value={{ fetchData }}>
      <div className={styles.mm_content}>
        <SearchGroup />
        {/* <ApprovalList /> */}
        {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
        <TablePage
          pagination={{
            total: !isEmptyObject(bizData) ? bizData.length : 0,
          }}
          loading={loading}
          tableData={bizData}
          loadingstatus={loading}
        />
      </div>
    </FunctionContext.Provider>
  );
};

export default Dr;
